import { Box, Button, Skeleton, Typography } from '@mui/material';
import { PromptLibraryItem, setSelectedPromptLibrary } from '../../../../store/one-query/promptLibrarySlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setShowSignPopup } from '../../../../store/one-query/chatsSlice';
import { useMemo } from 'react';

interface PromptProps {
  setLibraryPrompt: (prompt: string) => void;
  prompt: PromptLibraryItem;
}

export const Prompt = ({ prompt, setLibraryPrompt }: PromptProps) => {
  const dispatch = useAppDispatch();
  const User = useAppSelector((s) => s.User);

  const remainingSpace = prompt.contentLength - prompt.promptContent.length;

  // Memoizing the skeletons calculation to avoid re-renders
  const skeletons = useMemo(() => {
    const result = [];
    let spaceLeft = remainingSpace;

    while (spaceLeft > 0) {
      const randomWidth = Math.floor(Math.random() * 15) + 7;
      if (spaceLeft >= randomWidth) {
        result.push(
          <Skeleton
            key={result.length}
            animation={false}
            sx={{
              display: 'inline-block',
              width: `${randomWidth}ch`,
              height: '1.6em',
              marginBottom: 1,
              filter: 'blur(12px)',
              bgcolor: 'var(--Main_icons_color)',
              opacity: '0.3',
            }}
          />
        );
        spaceLeft -= randomWidth;
      } else {
        break;
      }
    }
    return result;
  }, [remainingSpace]);

  const handleSelectPromptLibrary = (pro: PromptLibraryItem) => {
    if(User.IsAuthenticated){
      if(pro.isPro && !User.isSubscribed){
        dispatch(
        setShowSignPopup({
          show: true,
          type: 'Prompt library',
          message: "To unlock this item, you must upgrade to Premium.",
          btnTitle:'Upgrade to premium',
          btnAction: 'OpenUpgradePlans',
        })
       );
      } else {
        setLibraryPrompt(pro.promptContent);
        dispatch(setSelectedPromptLibrary(pro));
      }
    } else {
      if(!User.IsAuthenticated && !pro.allowAnonymous){
        dispatch(
        setShowSignPopup({
          show: true,
          type: 'Prompt library',
          message: "To unlock prompt library you need to Sign in.",
          btnTitle: 'Sign In for Free' ,
          btnAction: 'NavigateToLogin' ,
        })
       );
      } else {
         setLibraryPrompt(pro.promptContent);
         dispatch(setSelectedPromptLibrary(pro));
      }
    }
  };

  const btnText = (!User.IsAuthenticated && prompt.allowAnonymous) || (User.IsAuthenticated && !prompt.isPro) || User.isSubscribed  ? "Use Prompt" 
  : !User.IsAuthenticated && !prompt.allowAnonymous && !prompt.isPro ? "Access for Free" : 
  !User.isSubscribed && prompt.isPro && "Go Premium";
  
  return (
    <Box className="library-prompt">
      <Typography className="prompt-title">{prompt.title}</Typography>
      <Typography className="prompt-desc" sx={{ display: 'inline' }}>
        {prompt.promptContent} {" "}
        {(prompt.isPro && !User.isSubscribed) || (!prompt.allowAnonymous && !User.IsAuthenticated) ? skeletons : null}
      </Typography>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
        <Button
          className="prompt-btn"
          variant="contained"
          onClick={() => handleSelectPromptLibrary(prompt)}
        >
          {btnText}
        </Button>
      </Box>
    </Box>
  );
};
